/**
 * Firestore `IAdvancedFilterGroup.grid` values that separate Advanced Filter categories.
 * Existing filters use {@link ADVANCED_FILTER_GRID_GENERAL}; Stock Take filters use
 * {@link ADVANCED_FILTER_GRID_STOCK_TAKE}.
 */
export const ADVANCED_FILTER_GRID_GENERAL = 'stock-manager';

/**
 * Grid value for Stock Take–only saved advanced filters.
 */
export const ADVANCED_FILTER_GRID_STOCK_TAKE = 'stock-take';

export type AdvancedFilterGridCategory =
  | typeof ADVANCED_FILTER_GRID_GENERAL
  | typeof ADVANCED_FILTER_GRID_STOCK_TAKE;

/**
 * Returns true when the filter belongs to the Stock Take category.
 */
export function isStockTakeAdvancedFilterGrid(grid: string | null | undefined): boolean {
  return grid === ADVANCED_FILTER_GRID_STOCK_TAKE;
}

/**
 * Returns true when the filter is General (Stock Manager). Missing/unknown grids
 * are treated as General so legacy documents remain usable.
 */
export function isGeneralAdvancedFilterGrid(grid: string | null | undefined): boolean {
  return !isStockTakeAdvancedFilterGrid(grid);
}

/**
 * Returns true when a filter matches the requested category grid.
 */
export function matchesAdvancedFilterGridCategory(
  filterGrid: string | null | undefined,
  categoryGrid: string,
): boolean {
  if (categoryGrid === ADVANCED_FILTER_GRID_STOCK_TAKE) {
    return isStockTakeAdvancedFilterGrid(filterGrid);
  }
  return isGeneralAdvancedFilterGrid(filterGrid);
}
